<template>
  <div class="stat">
    <div class="stat-name">
      <span v-text="this.$store.state.cropFacets[facetIndex].name"></span>
      <em v-text="this.$store.state.cropFacets[facetIndex].labels[value]"></em>
    </div>
    <div class="stat-bar">
      <div class="stat-bar-inner" :style="{width: barWidth}"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'facetIndex'],
  data () {
    return {}
  },
  computed: {
    barWidth () {
      let ratingValueNum = this.value
      if (this.$store.state.cropFacets[this.facetIndex].labels[this.value] === 'None') {
        ratingValueNum = 0
      }
      // shouldn't get a value more than 5 passed in, but just in case
      if (this.value > 5) {
        ratingValueNum = 5
      }
      return (ratingValueNum * 20) + '%'
    }
  }
}
</script>

<style lang="scss">
  .stat {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin: 14px 0 30px;

    .stat-name {
      display: flex;
    }
    span {
      display: block;
    }
    em {
      flex: 1;
      font-style: normal;
      display: block;
      text-align: right;
      font-size: 12px;
      line-height: 24px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: $color-ada-green-on-white;
    }
  }
  .stat-bar {
    height: 3px;
    width: 100%;
    border-radius: 3px;
    background: rgba($color-dark-green, 0.15);

    .stat-bar-inner {
      height: 3px;
      border-radius: 3px;
      background: $color-green;
    }
  }
</style>
